// See: https://github.com/ing-bank/lion/blob/master/docs/fundamentals/systems/form/model-value.md#event-meta
export type ModelValueChangeEvent<T> = CustomEvent<{
  isTriggeredByUser: boolean;
  formPath: { name: string; modelValue: T }[];
}>;

export type CheckboxModelValue = { checked: boolean };

type LionEventHandler<T> = (event: ModelValueChangeEvent<T>) => void;
export function inputValueChangeHandler<T>(callback: (value: T) => void): LionEventHandler<T> {
  return (event: ModelValueChangeEvent<T>) => {
    if (!event.detail.isTriggeredByUser) return;
    callback(event.detail.formPath[0].modelValue);
  };
}
